/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeightUpsertRequestDto
 */
export interface HeightUpsertRequestDto {
    /**
     * Height in feet
     * @type {number}
     * @memberof HeightUpsertRequestDto
     */
    feet: number;
    /**
     * Height in inches
     * @type {number}
     * @memberof HeightUpsertRequestDto
     */
    inches: number;
}

/**
 * Check if a given object implements the HeightUpsertRequestDto interface.
 */
export function instanceOfHeightUpsertRequestDto(value: object): value is HeightUpsertRequestDto {
    if (!('feet' in value) || value['feet'] === undefined) return false;
    if (!('inches' in value) || value['inches'] === undefined) return false;
    return true;
}

export function HeightUpsertRequestDtoFromJSON(json: any): HeightUpsertRequestDto {
    return HeightUpsertRequestDtoFromJSONTyped(json, false);
}

export function HeightUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeightUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'feet': json['feet'],
        'inches': json['inches'],
    };
}

export function HeightUpsertRequestDtoToJSON(json: any): HeightUpsertRequestDto {
    return HeightUpsertRequestDtoToJSONTyped(json, false);
}

export function HeightUpsertRequestDtoToJSONTyped(value?: HeightUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feet': value['feet'],
        'inches': value['inches'],
    };
}

